import React from 'react';

import { Provider as ReduxProvider } from 'react-redux';

import {
  useBi,
  useEnvironment,
  useExperiments,
  useTranslation,
} from '@wix/yoshi-flow-editor';

import { getStore, RootState } from '@/store';

import { useWidgetServices } from './WidgetServices';
import { useHttpClient } from './HttpClientProvider';

const isDev = process.env.NODE_ENV === 'development';

export const WidgetStoreProvider: React.FC<{
  initialState?: Partial<RootState>;
}> = React.memo(({ initialState, children }) => {
  const httpClient = useHttpClient();
  const { t } = useTranslation();
  const bi = useBi();
  const { experiments } = useExperiments();
  const environment = useEnvironment();
  const { duplexerConnection, siteEcomService: siteEcom } = useWidgetServices();
  const store = getStore({
    httpClient,
    t,
    bi,
    duplexerConnection,
    siteEcom,
    experiments,
    environment,
    preloadedState: { ...initialState },
    needDevTools: isDev,
    needLogger: isDev,
  });

  return <ReduxProvider store={store}>{children}</ReduxProvider>;
});
